export enum QDType {
	casino = 1,
	global = 5,
	sportsbook = 4,
	depositLogin = 3
}
